import { render, staticRenderFns } from "./EnterpriseTech.vue?vue&type=template&id=b08a741c&scoped=true"
import script from "./EnterpriseTech.vue?vue&type=script&lang=js"
export * from "./EnterpriseTech.vue?vue&type=script&lang=js"
import style0 from "./EnterpriseTech.vue?vue&type=style&index=0&id=b08a741c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08a741c",
  null
  
)

export default component.exports